(function () {
  function initReels(root) {
    var viewport = root.querySelector('.ir-reels__viewport');
    if (!viewport) return;

    var slides = Array.from(root.querySelectorAll('.ir-reels__slide'));
    var total = slides.length;
    if (total < 1) return;

    var current = 0;
    var liveEl = root.querySelector('.ir-reels__live');
    var liveSlideWord = root.getAttribute('data-ir-reels-live-slide') || 'Slide';
    var liveOfWord = root.getAttribute('data-ir-reels-live-of') || 'of';

    function updateLiveRegion() {
      if (!liveEl) return;
      liveEl.textContent = liveSlideWord + ' ' + String(current + 1) + ' ' + liveOfWord + ' ' + String(total);
    }

    function pauseAllVideos() {
      slides.forEach(function (s) {
        s.classList.remove('is-playing');
        var v = s.querySelector('video');
        if (v) v.pause();
      });
    }

    function wrapOffset(i, idx) {
      var raw = i - idx;
      if (raw > total / 2) raw -= total;
      if (raw < -total / 2) raw += total;
      return raw;
    }

    function setPositions(idx) {
      pauseAllVideos();
      slides.forEach(function (s, i) {
        var offset = wrapOffset(i, idx);
        if (offset >= -3 && offset <= 3) {
          s.setAttribute('data-pos', String(offset));
        } else {
          s.removeAttribute('data-pos');
        }
        s.classList.toggle('ir-reels__slide--featured', i === idx);
      });
      current = idx;
      updateLiveRegion();
    }

    function goTo(idx) {
      idx = ((idx % total) + total) % total;
      if (idx === current) return;
      setPositions(idx);
    }

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function (e) {
        if (e.target.closest('.ir-reels__play-btn')) return;
        if (e.target.closest('video') && slide.classList.contains('ir-reels__slide--featured')) return;
        if (i === current) return;
        e.preventDefault();
        goTo(i);
      });
    });

    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video) return;
      video.addEventListener('play', function () {
        slides.forEach(function (s) {
          var v = s.querySelector('video');
          if (v && v !== video) { v.pause(); s.classList.remove('is-playing'); }
        });
        slide.classList.add('is-playing');
      });
      video.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
      video.addEventListener('ended', function () {
        slide.classList.remove('is-playing');
        try { video.currentTime = 0; } catch (e) {}
      });
    });

    root.querySelectorAll('.ir-reels__play-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var slide = btn.closest('.ir-reels__slide');
        if (!slide || !slide.classList.contains('ir-reels__slide--featured')) return;
        var video = slide.querySelector('video');
        if (!video) return;
        pauseAllVideos();
        slide.classList.add('is-playing');
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    });

    root.querySelectorAll('.ir-reels__stage').forEach(function (stage) {
      stage.addEventListener('click', function (e) {
        var slide = stage.closest('.ir-reels__slide');
        if (!slide || !slide.classList.contains('is-playing')) return;
        if (e.target.closest('.ir-reels__play-btn')) return;
        var v = slide.querySelector('video');
        if (v && !v.paused) { v.pause(); slide.classList.remove('is-playing'); }
      }, true);
    });

    var touchStartX = 0;
    var swipeThreshold = 30;

    viewport.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    viewport.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < swipeThreshold) return;
      goTo(dx > 0 ? current - 1 : current + 1);
    });

    var dragStartX = 0;
    var dragActive = false;

    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (e.target.closest('.ir-reels__play-btn')) return;
      var slideEl = e.target.closest('.ir-reels__slide');
      if (e.target.closest('video') && slideEl && slideEl.classList.contains('ir-reels__slide--featured')) return;
      dragStartX = e.clientX;
      dragActive = true;
      e.preventDefault();
    });

    viewport.addEventListener('mousemove', function (e) {
      if (dragActive) e.preventDefault();
    });

    window.addEventListener('mouseup', function (e) {
      if (!dragActive) return;
      dragActive = false;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) < swipeThreshold) return;
      goTo(dx > 0 ? current - 1 : current + 1);
    });

    root.addEventListener('keydown', function (e) {
      if (!viewport.contains(e.target)) return;
      if (e.target && e.target.tagName === 'VIDEO') return;
      var key = e.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      e.preventDefault();
      if (key === 'ArrowLeft') goTo(current - 1);
      else if (key === 'ArrowRight') goTo(current + 1);
      else if (key === 'Home') goTo(0);
      else goTo(total - 1);
    });

    setPositions(Math.floor((total - 1) / 2));
  }

  document.querySelectorAll('[data-ir-reels-root]').forEach(function (root) {
    if (root.getAttribute('data-ir-reels-init') === '1') return;
    root.setAttribute('data-ir-reels-init', '1');
    initReels(root);
  });
})();
